import {

  GET_NOTARY_ORDERS_INVOICES_DT,
  GET_NOTARY_ORDERS_INVOICES_DT_OK,
  GET_NOTARY_ORDERS_INVOICES_DT_ERR,
  DO_NOTARY_ORDERS_INVOICES_DT_CLEANUP,

  APPLY_NOTARY_ORDERS_INVOICES_DT_FILTERS,
  PATCH_NOTARY_ORDERS_INVOICES_DT_FILTERS,
  CLEAR_NOTARY_ORDERS_INVOICES_DT_FILTERS,
  UNSET_NOTARY_ORDERS_INVOICES_DT_FILTERS,
} from "./actionTypes";

/********** DATATABLE **********/

export const getNotaryOrdersInvoicesDt = params => ({
  type: GET_NOTARY_ORDERS_INVOICES_DT,
  payload: { params },
});

export const getNotaryOrdersInvoicesDtOk = response => ({
  type: GET_NOTARY_ORDERS_INVOICES_DT_OK,
  payload: { response },
});

export const getNotaryOrdersInvoicesDtErr = error => ({
  type: GET_NOTARY_ORDERS_INVOICES_DT_ERR,
  payload: { error },
});

export const doNotaryOrdersInvoicesDtCleanup = () => ({
  type: DO_NOTARY_ORDERS_INVOICES_DT_CLEANUP,
});

/********** DATATABLE FILTERS **********/


export const applyNotaryOrdersInvoicesDtFilters = filters => ({
  type: APPLY_NOTARY_ORDERS_INVOICES_DT_FILTERS,
  payload: { filters },
});

export const patchNotaryOrdersInvoicesDtFilters = filters => ({
  type: PATCH_NOTARY_ORDERS_INVOICES_DT_FILTERS,
  payload: { filters },
});

export const clearNotaryOrdersInvoicesDtFilters = () => ({
  type: CLEAR_NOTARY_ORDERS_INVOICES_DT_FILTERS,
});

export const unsetNotaryOrdersInvoicesDtFilters = () => ({
  type: UNSET_NOTARY_ORDERS_INVOICES_DT_FILTERS,
});